import {Component, OnInit} from '@angular/core';
import {EnvironmentService} from '../services/environment.service';
import {TechnicianRegistration} from '../interface/config.interface';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

  technicianRegistration: TechnicianRegistration;

  constructor(private environmentService: EnvironmentService) {
  }

  ngOnInit(): void {
    this.technicianRegistration = this.environmentService.technicianRegistration;
  }
}
